export default __webpack_public_path__ + "static/man-on-tablet-636b6cfa4aca504a3c8abd786ebba83f.webp";